export default __webpack_public_path__ + "static/media/processed_icon.05ee819a.svg";